import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import LengthIcon from '../../../../../components/icons/length-icon.svg';
import WidthIcon from '../../../../../components/icons/width-icon.svg';
import HeightIcon from '../../../../../components/icons/height-icon.svg';
import { GradusIcon, HourIcon, KgIcon, MinuteIcon, SizeTextIcon } from '../../../../../components/text-icon';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { CustomLoader } from '../../../../../components/custom-loader';
import { ErrorComponent } from '../../../../../components/error-component';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { IcepacksComponent } from '../../icepacks-component';

export const ThermoboxReportFormView = ({
	thermoboxesOptions,
	isThermoboxesLoading,
	modesOptions,
	isModesLoading,
	icepacksOptions,
	isIcepacksLoading,
	isLoading,
}) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="thermobox-report-form">
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Дата проведения
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="date"
						nameField="date"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . / . . . ."
						dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Номер отчета
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="number"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите номер отчета"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Термоконтейнер
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="thermobox_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={thermoboxesOptions}
						search
						loading={isThermoboxesLoading}
						disabled={isThermoboxesLoading}
						noResultsMessage="Термоконтейнеры не найдены"
						placeholder="Выберите термоконтейнер"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Температурный режим
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="mode_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={modesOptions}
						search
						loading={isModesLoading}
						disabled={isModesLoading}
						noResultsMessage="Температурные режимы не найдены"
						placeholder="Выберите температурный режим"
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Кол-во повторностей
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="repeats"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите кол-во повторностей"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Время сохранения Т-режима
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<div className="order-group-form__time-fields">
						<div className="order-group-form__time-fields-wrapper">
							<div className="order-group-form__field order-group-form__field_with-time">
								<Field
									name="hold_hours"
									type="text"
									normalize={normalizeInteger}
									component={FormInputField}
									autoComplete="off"
									placeholder="Часы"
									icon={HourIcon}
								/>
							</div>
							<span className="order-group-form__time-fields-separator">-</span>
							<div className="order-group-form__field order-group-form__field_with-time">
								<Field
									name="hold_minutes"
									type="text"
									normalize={normalizeInteger}
									component={FormInputField}
									autoComplete="off"
									placeholder="Минуты"
									icon={MinuteIcon}
								/>
							</div>
						</div>
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Внешняя средняя температура
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="outer_mode"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите внешнюю среднюю температуру"
						icon={GradusIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Внутренние геометрические размеры комплекта
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Grid columns={3} className="thermobox-report-form__wrapper">
						<Grid.Row className="thermobox-report-form__row thermobox-report-form__row-cargo">
							<Grid.Column className="thermobox-report-form__column-cargo" width={5}>
								<img src={LengthIcon} alt="length-icon" />
								<div className="thermobox-report-form__field">
									<Field
										name="inner_length"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Дл."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-report-form__column-cargo" width={5}>
								<img src={WidthIcon} alt="width-icon" />
								<div className="thermobox-report-form__field">
									<Field
										name="inner_width"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Шир."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-report-form__column-cargo" width={5}>
								<img src={HeightIcon} alt="height-icon" />
								<div className="thermobox-report-form__field">
									<Field
										name="inner_height"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Выс."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="thermobox-report-form__row thermobox-report-form__row-cargo thermobox-report-form__row-error">
							<Grid.Column className="thermobox-report-form__column-cargo-error" width={16}>
								<Field name="inner_length" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-report-form__column-cargo-error" width={16}>
								<Field name="inner_width" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-report-form__column-cargo-error" width={16}>
								<Field name="inner_height" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-report-form__row">
				<Grid.Column width={6} className="thermobox-report-form__column">
					Масса комплекта на паллете
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-report-form__column">
					<Field
						name="pallet_weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите массу комплекта на паллете"
						icon={KgIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<FieldArray
				name="icepacks"
				component={IcepacksComponent}
				props={{
					icepacksOptions,
					isIcepacksLoading,
				}}
			/>
		</Grid>
	);
};

ThermoboxReportFormView.propTypes = {
	thermoboxesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isThermoboxesLoading: PropTypes.bool.isRequired,
	modesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	icepacksOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
};
